module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-vodafonerebranding-01@2x.b4a7f4f1.jpg";